import { Component, inject } from '@angular/core';
import { PmPinnedTimerComponent } from './shared/components/pm-pinned-timer/pm-pinned-timer.component';
import { RouterOutlet } from '@angular/router';
import { NgxSonnerToaster } from 'ngx-sonner';
import { PmOneLoginAuthGuard } from './features/auth/pm-onelogin-auth.guard';
import { PmLoadingOverlayComponent } from './shared/components/pm-loading-overlay/pm-loading-overlay.component';

@Component({
  selector: 'pm-root',
  standalone: true,
  imports: [RouterOutlet, NgxSonnerToaster, PmLoadingOverlayComponent, PmPinnedTimerComponent],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class AppComponent {
  readonly oneLoginGuard = inject(PmOneLoginAuthGuard);
}
